import React, { useMemo } from 'react';
import { ProviderProps } from '@app/shell/types';
import { isBrowser } from '@app/utils';
import Bowser from 'bowser';
import DeviceContext from '../../state/DeviceContext';

/**
 * We use memo here to ensure it runs on the server and client.
 *
 * @param children
 * @param req
 * @constructor
 */
const DeviceProvider = ({ children, req = undefined }: ProviderProps) => {
  const deviceValue = useMemo(() => {
    let userAgent: Nullable<string> = null;

    if (isBrowser) {
      // eslint-disable-next-line prefer-destructuring
      userAgent = window.navigator.userAgent;
    } else if (req) {
      userAgent = req?.headers?.['user-agent'] || null;
    }

    if (!userAgent) {
      return null;
    }

    return Bowser.getParser(userAgent);
  }, [req?.headers?.['user-agent']]);

  return (
    <DeviceContext.Provider value={deviceValue}>
      {children}
    </DeviceContext.Provider>
  );
};

export default DeviceProvider;
